import { useForm, ValidationError } from "@formspree/react";
import { navigate } from "gatsby";
import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

function ContactForm() {
	const [state, handleSubmit] = useForm("xldjrrda");

	useEffect(() => {
		if (state.succeeded) {
			navigate("/thank-you");
		}
	}, [state.succeeded]);

	return (
		<Form className="contact-form text-start" onSubmit={handleSubmit}>
			{/* Name Field */}
			<Form.Group controlId="name" className="mb-4">
				<Form.Label className="">Name:</Form.Label>
				<Form.Control
					className="special-placeholder"
					name="name"
					type="text"
					placeholder="Full name"
					style={nameInputStyles}
				/>
				<ValidationError prefix="Name" field="name" errors={state.errors} />
			</Form.Group>

			{/* Email Field */}
			<Form.Group controlId="email" className="mb-4">
				<Form.Label className="">Email:</Form.Label>
				<Form.Control
					className="special-placeholder"
					name="email"
					type="email"
					placeholder="email@example.com"
					style={emailInputStyles}
				/>
				<ValidationError prefix="Email" field="email" errors={state.errors} />
			</Form.Group>

			{/* Message Field */}
			<Form.Group controlId="message" className="mb-4">
				<Form.Control
					name="message"
					as="textarea"
					rows={5}
					placeholder="Type your message..."
					style={textareaStyles}
				/>
				<ValidationError
					prefix="Message"
					field="message"
					errors={state.errors}
				/>
			</Form.Group>

			{/* Accept Terms */}
			<Form.Group controlId="acceptTerms" className="mb-4">
				<Form.Check
					type="checkbox"
					label={
						<span className="calibri">
							I accept all the{" "}
							<a href="/website-terms-and-conditions" className=" fw-bold">
								Terms & Policies
							</a>{" "}
							of Premier Support Services
						</span>
					}
					required
					style={checkboxStyles}
				/>
			</Form.Group>

			{/* Submit Button */}
			<Button
				style={{ borderRadius: "0px" }}
				className="w-100 py-2"
				variant="primary"
				type="submit"
				disabled={state.submitting}
			>
				Submit
			</Button>
		</Form>
	);
}

export default ContactForm;
// 562A79
const nameInputStyles = {
	border: "none",
	borderBottom: "1px solid #CEE4FF",
	borderRadius: 0,
	padding: "10px",
	fontSize: "16px",
	color: "#333",
};

const emailInputStyles = {
	border: "none",
	borderBottom: "1px solid #CEE4FF",
	borderRadius: 0,
	padding: "10px",
	fontSize: "16px",
	color: "#333",
};

const textareaStyles = {
	border: "1px solid #CEE4FF",
	borderRadius: "0px",
	padding: "10px",
	fontSize: "16px",
	resize: "none",
};

const checkboxStyles = {
	marginTop: "10px",
	fontSize: "14px",
};
